// Auto-generated file - do not edit manually
// Generated by scripts/generate-docs.ts
// Maps block types to their icon component references for the integrations page

import type { ComponentType, SVGProps } from 'react'
import { Library, Rocket, Table } from '@sim/emcn/icons'
import {
  A2AIcon,
  AffinityIcon,
  AgentMailIcon,
  AgentPhoneIcon,
  AgiloftIcon,
  AhrefsIcon,
  AirtableIcon,
  AirweaveIcon,
  AlgoliaIcon,
  AmplitudeIcon,
  ApifyIcon,
  ApolloIcon,
  AppConfigIcon,
  ArxivIcon,
  AsanaIcon,
  AshbyIcon,
  AthenaIcon,
  AttioIcon,
  AzureDataExplorerIcon,
  AzureIcon,
  BitbucketIcon,
  BoxCompanyIcon,
  BrainIcon,
  BrandfetchIcon,
  BrexIcon,
  BrightDataIcon,
  BrowserUseIcon,
  BufferIcon,
  CalComIcon,
  CalendlyIcon,
  CbInsightsIcon,
  CirclebackIcon,
  ClaudeIcon,
  ClayIcon,
  ClerkIcon,
  ClickHouseIcon,
  ClickUpIcon,
  CloudFormationIcon,
  CloudflareIcon,
  CloudTrailIcon,
  CloudWatchIcon,
  CodaIcon,
  CodePipelineIcon,
  ConfluenceIcon,
  ContextDevIcon,
  ConvexIcon,
  CrowdStrikeIcon,
  CrunchbaseIcon,
  CursorIcon,
  DagsterIcon,
  DatabricksIcon,
  DatadogIcon,
  DatagmaIcon,
  DaytonaIcon,
  DevinIcon,
  DiscordIcon,
  DocumentIcon,
  DocuSignIcon,
  DowndetectorIcon,
  DropboxIcon,
  DropcontactIcon,
  DsPyIcon,
  DubIcon,
  DuckDuckGoIcon,
  DynamoDBIcon,
  DynatraceIcon,
  ElasticsearchIcon,
  ElevenLabsIcon,
  EmailBisonIcon,
  EmbeddingsIcon,
  EnrichmentIcon,
  EnrichSoIcon,
  EnrowIcon,
  ExaAIIcon,
  ExtendIcon,
  FathomIcon,
  FindymailIcon,
  FirecrawlIcon,
  FirefliesIcon,
  FlintIcon,
  GammaIcon,
  GithubIcon,
  GitLabIcon,
  GmailIcon,
  GongIcon,
  GoogleAdsIcon,
  GoogleAppsheetIcon,
  GoogleBigQueryIcon,
  GoogleBooksIcon,
  GoogleCalendarIcon,
  GoogleContactsIcon,
  GoogleDocsIcon,
  GoogleDriveIcon,
  GoogleFormsIcon,
  GoogleGroupsIcon,
  GoogleIcon,
  GoogleMapsIcon,
  GoogleMeetIcon,
  GooglePagespeedIcon,
  GoogleSheetsIcon,
  GoogleSlidesIcon,
  GoogleTasksIcon,
  GoogleTranslateIcon,
  GoogleVaultIcon,
  GrafanaIcon,
  GrainIcon,
  GranolaIcon,
  GreenhouseIcon,
  GreptileIcon,
  HarmonicIcon,
  HexIcon,
  HubspotIcon,
  HuggingFaceIcon,
  HumanInTheLoopIcon,
  HunterIOIcon,
  IAMIcon,
  IcypeasIcon,
  IdentityCenterIcon,
  IncidentioIcon,
  InfisicalIcon,
  InstantlyIcon,
  IntercomIcon,
  JinaAIIcon,
  JiraIcon,
  JiraServiceManagementIcon,
  JotformIcon,
  JupyterIcon,
  KalshiIcon,
  KetchIcon,
  LambdaIcon,
  LangsmithIcon,
  LatexIcon,
  LaunchDarklyIcon,
  LeadMagicIcon,
  LemlistIcon,
  LinearIcon,
  LinkedInIcon,
  LinkupIcon,
  LinqIcon,
  LogfireIcon,
  LogRocketIcon,
  LoopsIcon,
  LumaIcon,
  MailchimpIcon,
  MailgunIcon,
  MailServerIcon,
  ManageEngineIcon,
  Mem0Icon,
  MicrosoftDataverseIcon,
  MicrosoftExcelIcon,
  MicrosoftOneDriveIcon,
  MicrosoftPlannerIcon,
  MicrosoftSharepointIcon,
  MicrosoftSqlIcon,
  MicrosoftTeamsIcon,
  MicrosoftWordIcon,
  MillionVerifierIcon,
  MintlifyIcon,
  MistralIcon,
  ModalIcon,
  MondayIcon,
  MongoDBIcon,
  MySQLIcon,
  Neo4jIcon,
  NetSuiteIcon,
  NeverBounceIcon,
  NewRelicIcon,
  NotionIcon,
  ObsidianIcon,
  OktaIcon,
  OnePasswordIcon,
  OtterIcon,
  OutlookIcon,
  PackageSearchIcon,
  PagerDutyIcon,
  ParallelIcon,
  PeopleDataLabsIcon,
  PerplexityIcon,
  PersonaIcon,
  PineconeIcon,
  PipedriveIcon,
  PitchBookIcon,
  PlanetScaleIcon,
  PolymarketIcon,
  PostgresIcon,
  PosthogIcon,
  PowerBIIcon,
  ProfoundIcon,
  ProspeoIcon,
  PulseIcon,
  QdrantIcon,
  QuartrIcon,
  QuickBooksIcon,
  QuiverIcon,
  RabbitmqIcon,
  RailwayIcon,
  RB2BIcon,
  RDSIcon,
  RedditIcon,
  RedisIcon,
  ReductoIcon,
  ResendIcon,
  RevenueCatIcon,
  RipplingIcon,
  RocketlaneIcon,
  RootlyIcon,
  RssIcon,
  S3Icon,
  SailPointIcon,
  SalesforceIcon,
  SapConcurIcon,
  SapS4HanaIcon,
  SESIcon,
  SecretsManagerIcon,
  SemrushIcon,
  SendblueIcon,
  SendgridIcon,
  SentryIcon,
  SerperIcon,
  ServiceNowIcon,
  SftpIcon,
  ShopifyIcon,
  SimilarwebIcon,
  SimTriggerIcon,
  SixtyfourIcon,
  SlackIcon,
  SmartleadIcon,
  SmtpIcon,
  SnowflakeIcon,
  SplunkIcon,
  SportmonksIcon,
  SQSIcon,
  SquareIcon,
  SSMIcon,
  SshIcon,
  STSIcon,
  STTIcon,
  StagehandIcon,
  StripeIcon,
  SupabaseIcon,
  TailscaleIcon,
  TavilyIcon,
  TelegramIcon,
  TemporalIcon,
  TextractIcon,
  ThriveIcon,
  TikTokIcon,
  TinybirdIcon,
  TinyFishIcon,
  TrelloIcon,
  TriggerDevIcon,
  TwilioIcon,
  TypeformIcon,
  UpstashIcon,
  UptimeRobotIcon,
  VantaIcon,
  VercelIcon,
  WealthboxIcon,
  WebflowIcon,
  WebhookIcon,
  WhatsAppIcon,
  WikipediaIcon,
  WindchillIcon,
  WizaIcon,
  WordpressIcon,
  WorkdayIcon,
  xIcon,
  YouComIcon,
  YouTubeIcon,
  ZendeskIcon,
  ZepIcon,
  ZeroBounceIcon,
  ZohoDeskIcon,
  ZoomIcon,
  ZoomInfoIcon,
} from '@/components/icons'

type IconComponent = ComponentType<SVGProps<SVGSVGElement>>

export const blockTypeToIconMap: Record<string, IconComponent> = {
  a2a: A2AIcon,
  affinity: AffinityIcon,
  agentmail: AgentMailIcon,
  agentphone: AgentPhoneIcon,
  agiloft: AgiloftIcon,
  ahrefs: AhrefsIcon,
  airtable: AirtableIcon,
  airweave: AirweaveIcon,
  algolia: AlgoliaIcon,
  amplitude: AmplitudeIcon,
  apify: ApifyIcon,
  apollo: ApolloIcon,
  appconfig: AppConfigIcon,
  arxiv: ArxivIcon,
  asana: AsanaIcon,
  ashby: AshbyIcon,
  athena: AthenaIcon,
  attio: AttioIcon,
  azure_data_explorer: AzureDataExplorerIcon,
  azure_devops: AzureIcon,
  bitbucket: BitbucketIcon,
  box_v2: BoxCompanyIcon,
  brandfetch: BrandfetchIcon,
  brex: BrexIcon,
  brightdata: BrightDataIcon,
  browser_use: BrowserUseIcon,
  buffer: BufferIcon,
  calcom: CalComIcon,
  calendly: CalendlyIcon,
  cbinsights: CbInsightsIcon,
  circleback: CirclebackIcon,
  clay: ClayIcon,
  clerk: ClerkIcon,
  clickhouse: ClickHouseIcon,
  clickup: ClickUpIcon,
  cloudflare: CloudflareIcon,
  cloudformation: CloudFormationIcon,
  cloudtrail: CloudTrailIcon,
  cloudwatch: CloudWatchIcon,
  coda: CodaIcon,
  codepipeline: CodePipelineIcon,
  confluence: ConfluenceIcon,
  confluence_v2: ConfluenceIcon,
  context_dev: ContextDevIcon,
  convex: ConvexIcon,
  crowdstrike: CrowdStrikeIcon,
  crunchbase: CrunchbaseIcon,
  cursor_v2: CursorIcon,
  dagster: DagsterIcon,
  databricks: DatabricksIcon,
  datadog: DatadogIcon,
  datagma: DatagmaIcon,
  daytona: DaytonaIcon,
  deployments: Rocket,
  devin: DevinIcon,
  discord: DiscordIcon,
  docusign: DocuSignIcon,
  downdetector: DowndetectorIcon,
  dropbox_v2: DropboxIcon,
  dropcontact: DropcontactIcon,
  dspy: DsPyIcon,
  dub_v2: DubIcon,
  duckduckgo: DuckDuckGoIcon,
  dynamodb: DynamoDBIcon,
  dynatrace: DynatraceIcon,
  elasticsearch: ElasticsearchIcon,
  elevenlabs: ElevenLabsIcon,
  emailbison: EmailBisonIcon,
  embeddings: EmbeddingsIcon,
  enrich: EnrichSoIcon,
  enrichment: EnrichmentIcon,
  enrow: EnrowIcon,
  exa: ExaAIIcon,
  extend_v2: ExtendIcon,
  fathom: FathomIcon,
  file_v5: DocumentIcon,
  findymail: FindymailIcon,
  firecrawl: FirecrawlIcon,
  fireflies: FirefliesIcon,
  fireflies_v2: FirefliesIcon,
  flint: FlintIcon,
  gamma: GammaIcon,
  generic: WebhookIcon,
  github: GithubIcon,
  github_v2: GithubIcon,
  gitlab: GitLabIcon,
  gmail: GmailIcon,
  gmail_v2: GmailIcon,
  gong: GongIcon,
  google_ads: GoogleAdsIcon,
  google_appsheet: GoogleAppsheetIcon,
  google_bigquery: GoogleBigQueryIcon,
  google_books: GoogleBooksIcon,
  google_calendar_v2: GoogleCalendarIcon,
  google_contacts: GoogleContactsIcon,
  google_docs: GoogleDocsIcon,
  google_drive: GoogleDriveIcon,
  google_forms: GoogleFormsIcon,
  google_groups: GoogleGroupsIcon,
  google_maps: GoogleMapsIcon,
  google_meet: GoogleMeetIcon,
  google_pagespeed: GooglePagespeedIcon,
  google_search: GoogleIcon,
  google_sheets_v2: GoogleSheetsIcon,
  google_slides_v2: GoogleSlidesIcon,
  google_tasks: GoogleTasksIcon,
  google_translate: GoogleTranslateIcon,
  google_vault: GoogleVaultIcon,
  'google-calendar': GoogleCalendarIcon,
  'google-drive': GoogleDriveIcon,
  'google-sheets': GoogleSheetsIcon,
  grafana: GrafanaIcon,
  grain: GrainIcon,
  grain_v2: GrainIcon,
  granola: GranolaIcon,
  greenhouse: GreenhouseIcon,
  greptile: GreptileIcon,
  harmonic: HarmonicIcon,
  hex: HexIcon,
  hubspot: HubspotIcon,
  huggingface: HuggingFaceIcon,
  human_in_the_loop_v2: HumanInTheLoopIcon,
  hunter: HunterIOIcon,
  iam: IAMIcon,
  icypeas: IcypeasIcon,
  identity_center: IdentityCenterIcon,
  imap: MailServerIcon,
  incidentio: IncidentioIcon,
  infisical: InfisicalIcon,
  instantly: InstantlyIcon,
  intercom: IntercomIcon,
  intercom_v2: IntercomIcon,
  jina: JinaAIIcon,
  jira: JiraIcon,
  jira_service_management: JiraServiceManagementIcon,
  jotform: JotformIcon,
  jsm: JiraServiceManagementIcon,
  jupyter_v2: JupyterIcon,
  kalshi_v2: KalshiIcon,
  ketch: KetchIcon,
  knowledge: PackageSearchIcon,
  lambda: LambdaIcon,
  langsmith: LangsmithIcon,
  latex: LatexIcon,
  launchdarkly: LaunchDarklyIcon,
  leadmagic: LeadMagicIcon,
  lemlist: LemlistIcon,
  linear: LinearIcon,
  linear_v2: LinearIcon,
  linkedin: LinkedInIcon,
  linkup: LinkupIcon,
  linq: LinqIcon,
  logfire: LogfireIcon,
  logrocket: LogRocketIcon,
  logs_v2: Library,
  loops: LoopsIcon,
  luma: LumaIcon,
  mailchimp: MailchimpIcon,
  mailgun: MailgunIcon,
  managed_agent: ClaudeIcon,
  manageengine_sdp: ManageEngineIcon,
  mem0: Mem0Icon,
  memory: BrainIcon,
  microsoft_ad: AzureIcon,
  microsoft_dataverse_v2: MicrosoftDataverseIcon,
  microsoft_dynamics_365: MicrosoftDataverseIcon,
  microsoft_excel_v2: MicrosoftExcelIcon,
  microsoft_planner: MicrosoftPlannerIcon,
  microsoft_teams: MicrosoftTeamsIcon,
  microsoft_word: MicrosoftWordIcon,
  'microsoft-teams': MicrosoftTeamsIcon,
  millionverifier: MillionVerifierIcon,
  mintlify: MintlifyIcon,
  mistral_parse_v3: MistralIcon,
  modal: ModalIcon,
  monday: MondayIcon,
  mongodb: MongoDBIcon,
  mssql: MicrosoftSqlIcon,
  mysql: MySQLIcon,
  neo4j: Neo4jIcon,
  netsuite: NetSuiteIcon,
  neverbounce: NeverBounceIcon,
  new_relic: NewRelicIcon,
  notion: NotionIcon,
  notion_v2: NotionIcon,
  obsidian: ObsidianIcon,
  okta: OktaIcon,
  onedrive: MicrosoftOneDriveIcon,
  onepassword: OnePasswordIcon,
  otter: OtterIcon,
  outlook: OutlookIcon,
  pagerduty: PagerDutyIcon,
  parallel_ai: ParallelIcon,
  peopledatalabs: PeopleDataLabsIcon,
  perplexity: PerplexityIcon,
  persona: PersonaIcon,
  pinecone: PineconeIcon,
  pipedrive: PipedriveIcon,
  pitchbook: PitchBookIcon,
  planetscale: PlanetScaleIcon,
  polymarket: PolymarketIcon,
  postgresql: PostgresIcon,
  posthog: PosthogIcon,
  powerbi: PowerBIIcon,
  profound: ProfoundIcon,
  prospeo: ProspeoIcon,
  pulse_v2: PulseIcon,
  qdrant: QdrantIcon,
  quartr: QuartrIcon,
  quickbooks: QuickBooksIcon,
  quiver_v2: QuiverIcon,
  rabbitmq: RabbitmqIcon,
  railway: RailwayIcon,
  rb2b: RB2BIcon,
  rds: RDSIcon,
  reddit: RedditIcon,
  redis: RedisIcon,
  reducto_v2: ReductoIcon,
  resend: ResendIcon,
  revenuecat: RevenueCatIcon,
  rippling: RipplingIcon,
  rocketlane: RocketlaneIcon,
  rootly: RootlyIcon,
  rss: RssIcon,
  s3: S3Icon,
  sailpoint: SailPointIcon,
  salesforce: SalesforceIcon,
  sap_concur: SapConcurIcon,
  sap_s4hana: SapS4HanaIcon,
  secrets_manager: SecretsManagerIcon,
  semrush: SemrushIcon,
  sendblue: SendblueIcon,
  sendgrid: SendgridIcon,
  sentry: SentryIcon,
  serper: SerperIcon,
  servicenow: ServiceNowIcon,
  servicenow_v2: ServiceNowIcon,
  ses: SESIcon,
  sftp_v2: SftpIcon,
  sharepoint_v2: MicrosoftSharepointIcon,
  shopify: ShopifyIcon,
  sim_workspace_event: SimTriggerIcon,
  similarweb: SimilarwebIcon,
  sixtyfour: SixtyfourIcon,
  slack: SlackIcon,
  slack_app: SlackIcon,
  slack_v2: SlackIcon,
  smartlead: SmartleadIcon,
  smtp: SmtpIcon,
  snowflake: SnowflakeIcon,
  splunk: SplunkIcon,
  sportmonks: SportmonksIcon,
  sqs: SQSIcon,
  square: SquareIcon,
  ssh_v2: SshIcon,
  ssm: SSMIcon,
  stagehand: StagehandIcon,
  stripe: StripeIcon,
  sts: STSIcon,
  stt_v2: STTIcon,
  supabase: SupabaseIcon,
  table: Table,
  table_v2: Table,
  tailscale: TailscaleIcon,
  tavily: TavilyIcon,
  telegram: TelegramIcon,
  temporal: TemporalIcon,
  textract_v2: TextractIcon,
  thrive: ThriveIcon,
  tiktok: TikTokIcon,
  tinybird: TinybirdIcon,
  tinyfish: TinyFishIcon,
  trello: TrelloIcon,
  trigger_dev: TriggerDevIcon,
  twilio: TwilioIcon,
  twilio_sms: TwilioIcon,
  twilio_voice: TwilioIcon,
  typeform: TypeformIcon,
  upstash: UpstashIcon,
  uptimerobot: UptimeRobotIcon,
  vanta: VantaIcon,
  vercel: VercelIcon,
  wealthbox: WealthboxIcon,
  webflow: WebflowIcon,
  whatsapp: WhatsAppIcon,
  wikipedia: WikipediaIcon,
  windchill: WindchillIcon,
  wiza: WizaIcon,
  wordpress: WordpressIcon,
  workday: WorkdayIcon,
  x: xIcon,
  youcom: YouComIcon,
  youtube: YouTubeIcon,
  zendesk: ZendeskIcon,
  zep: ZepIcon,
  zerobounce: ZeroBounceIcon,
  zoho_desk: ZohoDeskIcon,
  zoom: ZoomIcon,
  zoominfo: ZoomInfoIcon,
}
